import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
import { getApi } from "../api/endpoints";
import { useDispatch, useSelector } from "react-redux";

const SetUserBranch = (props) => {
  const [updateBranchApi] = getApi('updateUser');
  const [branchesApi] = getApi('branches');
  const params = useParams();
  const [selectedBranchId, setSelectedBranchId] = useState(undefined);
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();

  useEffect(()=> {
    getBranches();
  }, [])

  const getBranches = async () => {
     try {
      let response = await branchesApi({ fields: "options" }).unwrap();
      setBranches(response.data.branches);
    } catch(error) {
      toast.error(error.message)
    }
  }

  const setBranchOfUser = async (e) => {
    try {
      if(selectedBranchId) {
        let response = await updateBranchApi({ id: params.id, user: {branch_id: selectedBranchId} }).unwrap();
        navigate(0)
      } else {
        throw {message: "Please select a circle"}
      }
    } catch(error) {
      toast.error(error.message)
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <p style={{ paddingLeft: "15px" }} className="h5 my-3">
          You need to select a circle first to map pincodes to the user.
        </p>
        <div className="col-md-3 my-2">
          <label htmlFor="name" className="form-label mb-0">Select a circle for user</label>
          <Multiselect
            options={branches}
            onSelect={(selectedList, selectedItem)=> setSelectedBranchId(selectedItem.id)}
            onRemove={(removedList, removedItem)=> setSelectedBranchId(null)}
            selectionLimit={1}
            displayValue="name"
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
          />
        </div>
      </div>
      <div className="my-2">
        <button type="button" onClick={setBranchOfUser} className="btn btn-voltup-theme" style={{ float: 'inline-start' }}>
          Set Circle
        </button>
      </div>
    </React.Fragment>
  );
};

export default SetUserBranch;
